import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import styled from 'styled-components';
import colors from '../../Sidebar/colors';
import ProMenu from '../../MenuFragments/Pro';
import ReactMenu from '../../MenuFragments/React';
import UserContext from '../../../context/UserContext';
import Copyright from '../../Sidebar/Copyright';
import Logout from '../../Sidebar/Logout';

const FullScreenMenu = styled.div`
	position: fixed;
	left: 0;
	top: ${props => props.top};
	width: 100vw;
	height: 100vh;
	transform: translate3d(${props => (props.open ? '0vw' : '100vw')}, 0, 0);
	transition: transform 0.3s cubic-bezier(0, 0.52, 0, 1);
	z-index: 10000;

	box-sizing: border-box;
	background-color: ${colors.navBg};
	color: ${colors.white};
`;

const Footer = styled.div`
	position: absolute;
	width: 100%;
	bottom: 65px;
`;

const Menu = ({ headerHeight, isOpen }) => {
	const [openMenu, setOpenMenu] = useState('');

	const toggleMenu = menu =>
		openMenu === menu ? setOpenMenu('') : setOpenMenu(menu);

	const {
		user: { productClaims }
	} = useContext(UserContext);

	useEffect(() => {
		document.body.style.overflow = isOpen ? 'hidden' : '';
		if (isOpen === false) {
			setOpenMenu('');
		}
	}, [isOpen]);

	return ReactDOM.createPortal(
		<FullScreenMenu top={headerHeight} open={isOpen} role="menu">
			<ReactMenu
				isOpen={openMenu === 'react'}
				onShowHide={() => toggleMenu('react')}
				productClaims={productClaims}
			/>

			<ProMenu
				isOpen={openMenu === 'pro'}
				onShowHide={() => toggleMenu('pro')}
				productClaims={productClaims}
			/>

			{/* <HelpMenu
				isOpen={openMenu === 'help'}
				onShowHide={() => toggleMenu('help')}
				productClaims={productClaims}
			/> */}

			<Footer>
				<Logout isOpen={isOpen} />
				<Copyright isMobile isCollapsed={false} originYear={2020} />
			</Footer>
		</FullScreenMenu>,
		document.body
	);
};

Menu.propTypes = {
	headerHeight: PropTypes.string.isRequired,
	isOpen: PropTypes.bool.isRequired
};

export default Menu;
